import { ListItemButton, ListItemText } from '@mui/material';

import { LinkListItem } from '.';

import type { LinkListItemProps } from '.';
import type { FC } from 'react';

/**
 * LinkListItemButton
 * LinkListItem wrapping a List- StyledButton > Text element
 * @augments LinkListItem
 */

export const LinkListItemButton: FC<LinkListItemProps> = ({
  children = null,
  ...props
}) => (
  <LinkListItem {...props}>
    <ListItemButton>
      <ListItemText>{children}</ListItemText>
    </ListItemButton>
  </LinkListItem>
);
